import type { IconSvgObject } from './types';

const EuroSendIcon: IconSvgObject = [
  ["path", { d: "M3 10H9M3 14H9M14 6C13.0521 4.77011 11.6954 4 10.1887 4C7.32306 4 5 6.78578 5 10.2222V13.7778C5 17.2142 7.32306 20 10.1887 20C11.6954 20 13.0521 19.2299 14 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 14.5L21 12L18.5 9.5M14 12H20.3912", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default EuroSendIcon;
